import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Bijlage } from '../types/Bijlage'

export { openBijlageForEntity }

const openBijlageForEntity = async ({
  entity: { type, id },
  bijlage: { _id },
}: {
  entity: Entity
  bijlage: Bijlage
}) => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/bijlage/${_id}`,
    method: 'GET',
  })

  const { url: downloadUrl } = data.downloadData

  window.open(downloadUrl, '_blank')
}
